export const SENTRY_SCOPE = {
    BOOKING_DATA: 'bookingData',
    OPERATION: 'operation',
    USER_DATA: 'userData'
};
//# sourceMappingURL=sentry.js.map